module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_photowedding_01@3x-e2868cc2351458fb6145573ad581fb60.webp";